"use client";

import { ArrowRight, ClipboardList, FileText, MapPin, Truck, PackageOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CMoFuncionaElEcosistema() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: timelineRef,
    isVisible: timelineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const steps = [{
    number: "01",
    title: "Solicitud de Servicio",
    description: "El huésped solicita un carrito desde la app, indicando su ubicación actual y destino.",
    Icon: FileText
  }, {
    number: "02",
    title: "Asignación Inteligente",
    description: "Nuestro algoritmo localiza el carrito más cercano y optimiza la ruta de recogida.",
    Icon: ClipboardList
  }, {
    number: "03",
    title: "Seguimiento en Vivo",
    description: "El huésped visualiza en tiempo real el movimiento del carrito y el tiempo estimado de llegada.",
    Icon: Truck
  }, {
    number: "04",
    title: "Llegada y Servicio",
    description: "El carrito llega a su posición exacta, completando el traslado de forma eficiente.",
    Icon: PackageOpen
  }];
  return;
}